export const environment = {
    production: false,
    baseUrlFake: "https://powerdashboard.vn/api",
    baseUrl: "https://powerdashboard.vn/api",
};
